export declare interface FreeTrialInfo {
  isFreeTrial?: boolean;
  startDate?: string;
  endDate?: string;
  cancelDate?: string;
  freeTrialDuration?: string;
  subscriptionAmount?: number;
  subscriptionUnitPrice?: number;
  subscriptionTax?: number;
  subscriptionDigitalServiceFees?: number;
  status?: FreeTrialStatus;
  purchaseOrderNumber?: string;
}

export enum FreeTrialStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED'
}